import { Injectable, inject, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Tarif } from '../models/Tarif/TarifRecent';
import { Observable, map, tap } from 'rxjs';
import { ResultatRechercheVin } from '../models/Tarif/ResultatRechercheVin';
import { VinSiteClient } from '../models/Vin/VinSiteClient';

@Injectable({
  providedIn: 'root'
})
export class TarifService {

  private apiGccUrl = environment.api + 'bff/';
  private http = inject(HttpClient);

  public isLoading = signal<boolean>(false);

  public getTarifRecents(): Observable<Tarif[]> {
    this.isLoading.set(true);
    return this.http.get<Tarif[]>(`${ this.apiGccUrl }Catalogues/RechercheTarifRecentsSiteClient`)
    .pipe(
      tap(() => this.isLoading.set(false)),
      map(tarifs => tarifs.map(tarif => ({
        ...tarif,
        pays: tarif.pays?.toLowerCase(),
        centilisation: Number(tarif.centilisation)
      })))
    );
  }

  public rechercheTarif(idVin: string | null): Observable<Tarif[]> {
    const params: {[key: string]: string} = {};
    if (idVin) {
      params['idVin'] = idVin;
    }

    this.isLoading.set(true);
    return this.http.get<Tarif[]>(`${ this.apiGccUrl }Catalogues/RechercheRapideSiteClient`, { params })
    .pipe(
      tap(() => this.isLoading.set(false)),
      map(tarifs => tarifs.map(tarif => ({
        ...tarif,
        pays: tarif.pays?.toLowerCase(),
        centilisation: Number(tarif.centilisation),
      })))
    );
  }

  public rechercheVin(texte: string): Observable<ResultatRechercheVin[]> {
    const params: { texte: string } = { texte };
    return this.http.get<ResultatRechercheVin[]>(`${ this.apiGccUrl }Catalogues/RechercherVin`, { params });
  }

  public getVinById(idVin: string): Observable<VinSiteClient> {
    const params: { idVin: string } = { idVin };
    return this.http.get<VinSiteClient>(`${ this.apiGccUrl }Catalogues/RechercherInfoVin`, { params }).pipe(
      map((vin: VinSiteClient): VinSiteClient => ({
        ...vin,
        urlInstagram: this.getUrl(vin?.urlInstagram),
        urlChateau: this.getUrl(vin?.urlChateau),
      }))
    );
  }

  private getUrl(url?: string): string | undefined {
    return url && !url.startsWith('http') ? `https://${url}` : url;
  }

  rechercheVinsNonSortis(texte: string) {
    const params: { texte: string } = { texte };
    return this.http.get<ResultatRechercheVin[]>(`${ this.apiGccUrl }Catalogues/RechercherVinsNonSortis`, { params });
  }

  rechercheVinsNonSortisMem(typeMem: number, texte: string) {
    const params: { typeMem: number, texte: string } = { typeMem, texte };
    return this.http.get<ResultatRechercheVin[]>(`${ this.apiGccUrl }Catalogues/RechercherVinsNonSortisMem`, { params });
  }
}
